import React from "react";

const MastiStatsAndFilter = ({
  stats,
  search,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  statusFilter,
  onStatusFilterChange,
}) => {
  const cards = [
    {
      label: "Total Pending",
      count: stats.pending,
      icon: "🎉",
      bg: "bg-pink-50",
      border: "border-pink-100",
      iconBg: "bg-pink-100",
    },
    {
      label: "Total Approved",
      count: stats.approved,
      icon: "✅",
      bg: "bg-green-50",
      border: "border-green-100",
      iconBg: "bg-green-100",
    },
    {
      label: "Total Rejected",
      count: stats.rejected,
      icon: "❌",
      bg: "bg-red-50",
      border: "border-red-100",
      iconBg: "bg-red-100",
    },
  ];

  const tabs = [
    { label: "All", value: "All" },
    { label: "Pending", value: "Pending" },
    { label: "Accepted", value: "Approved" },
    { label: "Rejected", value: "Rejected" },
    { label: "Live", value: "Live" },
  ];

  return (
    <div className="mb-6">
      {/* Stats */}
      <div className="mb-6 flex flex-wrap gap-4">
        {cards.map((c) => (
          <div
            key={c.label}
            className={`flex min-w-[160px] flex-1 items-center gap-4 rounded-2xl border bg-white ${c.border} ${c.bg} px-6 py-5 shadow-sm transition-shadow hover:shadow-md`}
          >
            <div
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${c.iconBg}`}
            >
              <span className="text-xl">{c.icon}</span>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">{c.label}</p>
              <p className="text-2xl font-bold text-gray-800">
                {c.count ?? "—"}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Tabs + Search + Type Filter */}
      <div className="flex flex-col gap-3 rounded-2xl bg-white p-5 sm:flex-row sm:items-center sm:justify-between">
        {/* Status Tabs — left */}
        <div className="flex items-center gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              onClick={() => onStatusFilterChange(tab.value)}
              className={`rounded-full px-5 py-2 text-sm font-medium transition-all duration-150 ${
                statusFilter === tab.value
                  ? "bg-[#c51369] text-white shadow-sm"
                  : "bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Right side: Type filter + Search */}
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          {/* Type filter */}
          <div className="flex w-full items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2.5 shadow-sm sm:w-44">
            <span className="text-[#c51369]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z"
                />
              </svg>
            </span>
            <select
              value={typeFilter}
              onChange={(e) => onTypeFilterChange(e.target.value)}
              className="bg-transparent flex-1 cursor-pointer text-sm text-gray-700 outline-none"
            >
              <option value="All">All Types</option>
              <option value="Paid">Paid</option>
              <option value="Free">Free</option>
            </select>
          </div>

          {/* Search */}
          <div className="flex w-full items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2.5 shadow-sm sm:w-80">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 shrink-0 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z"
              />
            </svg>
            <input
              type="text"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search by name, language, phone..."
              className="bg-transparent flex-1 text-sm text-gray-700 placeholder-gray-400 outline-none"
            />
            {search && (
              <button
                onClick={() => onSearchChange("")}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MastiStatsAndFilter;
